import { toast } from './toast';
import { handleAuthError } from './auth';

const handleError = (error: any) => {
  let message = 'An unexpected error occurred';
  
  // Handle specific error cases
  if (error?.message?.includes('session_not_found')) {
    handleAuthError();
    return;
  } else if (error?.message?.includes('JWT expired')) {
    handleAuthError();
    return;
  } else if (error?.message?.includes('invalid token')) {
    handleAuthError();
    return;
  } else if (error?.message?.includes('Invalid login credentials')) {
    message = 'Invalid email or password. Please check your credentials.';
  } else if (isNetworkError(error)) {
    message = 'Unable to connect to the server. Please check your internet connection.';
  } else if (error instanceof Error) {
    message = error.message;
  }
  
  // Log error for debugging
  console.error('API Error:', {
    message,
    originalError: error
  });

  // Show user-friendly error message
  toast.error(message);
};

export const isNetworkError = (error: any): boolean => {
  return error instanceof TypeError && (
    error.message === 'Failed to fetch' ||
    error.message.includes('NetworkError') ||
    error.message.includes('Network request failed') ||
    error.message.includes('network error') ||
    error.message.includes('Failed to connect')
  );
};

;